import { createContext, useContext } from 'react';
import useSearchFormTabNavigation from '../../../../../hooks/ui/useSearchFormTabNavigation';
import {usePartnerSearchContext} from "../../Partner/Search";

const NavigationBetweenSearchFormsContext = createContext();

export function useNavigationBetweenSearchFormsContext() {
  const context = useContext(NavigationBetweenSearchFormsContext);
  if (!context) {
    console.error('useNavigationBetweenSearchFormsContext: the component from which you are trying to use this context must be a ContextProviderNavigation component descendant.');
  }
  return context;
}

export default function ContextProviderNavigationBetweenSearchForms({children}) {

  const { selectedCountry } = usePartnerSearchContext();

  const {
    getCurrentSelectedForm,
    selectFilterByNeedForm,
    selectSearchByCombinedCriteriaForm,
    selectSearchByLocationForm,
    selectFormBeforeSearchByLocation,
    isFilterByNeedFormSelected,
    isSearchByCombinedCriteriaFormSelected,
    isSearchByLocationFormSelected
  } = useSearchFormTabNavigation(selectedCountry);

  return (
    <NavigationBetweenSearchFormsContext.Provider value={
      {
        getCurrentSelectedForm,
        selectFilterByNeedForm,
        selectSearchByCombinedCriteriaForm,
        selectSearchByLocationForm,
        selectFormBeforeSearchByLocation,
        isFilterByNeedFormSelected,
        isSearchByCombinedCriteriaFormSelected,
        isSearchByLocationFormSelected
      }
    }>{children}</NavigationBetweenSearchFormsContext.Provider>
  );
}
